/**
 * Wrappers for sending HTTP requests to the staffMemberships API.
 *
 * Provided by the StaffMemberships store, but does not directly interact with the store.
 */
import URI from 'jsuri';
import Q from 'q';

import type { API as Api } from 'js/lib/api';
import API from 'js/lib/api';

import type { PartnerRoleTemplateInterface } from '../types';

const _api = API('/api/partnerRoleTemplates.v1/', { type: 'rest' });

/** Objects returned from a request. */
export type PartnerRoleTemplatesAPIGetResponseInterface = {
  elements: Array<PartnerRoleTemplateInterface>;
  paging?: {};
  linked?: {};
};

/**
 * Get all the memberships related to a particular partner.
 */
export const getAll = ({
  limit = 1000,
  /** Roles are only associated with partners. */
  partnerId,

  // DI, mainly for testing.
  api = _api,
}: {
  limit?: number;
  partnerId: string | number;
  api?: Api;
}): Q.Promise<PartnerRoleTemplatesAPIGetResponseInterface> => {
  const uri = new URI()
    .addQueryParam('fields', 'displayName,hydrateRolesForEntityTypes')
    .addQueryParam('includeUniversalTemplates', 'true')
    .addQueryParam('q', 'byPartnerId')
    .addQueryParam('limit', limit)
    .addQueryParam('partnerId', partnerId);

  return Q(api.get<PartnerRoleTemplatesAPIGetResponseInterface>(uri.toString()));
};
